import "./CostSummaryViewer.css";

import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import AlertLoading from "components/AlertLoading";
import StartWorkBox from "components/StartWorkBox";
import { fetchCostSummaryViewerData } from "slices/costSummary";
import { getCostSummaryFetchStatus, getCostSummaryFetchStatusText } from "slices/costSummary/costSummarySelectors";
import { costSummaryActions } from "slices/costSummary/costSummarySlice";
import { setCurrentEstmDocId, setCurrentPage } from "slices/ribbon";

import CostSummaryCostSignatures from "./components/CostSummaryCostSignatures/CostSummaryCostSignatures";
import CostSummaryCostTable from "./components/CostSummaryCostTable/CostSummaryCostTable";
import CostSummaryHeader from "./components/CostSummaryHeader/CostSummaryHeader";
import CostSummaryTable from "./components/CostSummaryTable/CostSummaryTable";
import CostSummaryTableSignatures from "./components/CostSummaryTableSignatures/CostSummaryTableSignatures";

const CostSummaryViewer = ({ scrollBlock }) => {
	const dispatch = useDispatch();

	const fetchStatus = useSelector(getCostSummaryFetchStatus);
	const fetchStatusText = useSelector(getCostSummaryFetchStatusText);
	const { costSummaryId } = useParams();
	const headBlock1 = useRef();
	const headBlock2 = useRef();

	useEffect(() => {
		dispatch(setCurrentPage("CostSummaryViewer"));
		if (!costSummaryId) return;
		dispatch(fetchCostSummaryViewerData({ costSummaryId }));
		dispatch(setCurrentEstmDocId(costSummaryId));
	}, [costSummaryId, dispatch]);

	if (!costSummaryId) return <StartWorkBox />;

	return (
		<div className="TableOuterBox" type="CostSummaryViewer">
			<div className="CostSummaryViewerLayout">
				<CostSummaryHeader refBlocks={{ headBlock1, headBlock2 }} />
				<CostSummaryCostTable />
				<CostSummaryCostSignatures />
				<CostSummaryTable />
				<CostSummaryTableSignatures />
				<AlertLoading fetchStatus={fetchStatus} fetchStatusText={fetchStatusText} func={costSummaryActions.setFetchStatus} />
			</div>
		</div>
	);
};

export default CostSummaryViewer;
